import { createVNode as n, mergeProps as a } from "vue";
import i from "../node_modules/@pf-ui/pf-icon-svg/es/asn/FilePngTwotoneStandard.js";
import d from "../components/PfIcon.js";
const t = (o, r) => {
  const e = {
    ...o,
    ...r.attrs
  };
  return n(d, a(e, {
    icon: i
  }), null);
};
t.displayName = "FilePngTwotoneStandard";
t.inheritAttrs = !1;
export {
  t as default
};
